import React,{useState, useEffect} from 'react';
import useStyles from './styles';
import {TextField,Button, Typography, Paper} from '@material-ui/core';
import FileBase from 'react-file-base64';
import {useDispatch} from 'react-redux';
import {useSelector} from 'react-redux';

import { createPost,updatePost} from '../../actions/posts';



const Form = ({currentId, setCurrentId}) => {
    const [postData, setPostData] = useState({
        criador: '', titulo: '', mensagem:'', tags: '',selectedFile: ''});
        const post = useSelector((state) => currentId ? state.posts.find((p) => p._id === currentId) : null);
    const classes = useStyles();
    const dispatch = useDispatch();
    useEffect(() => {
        if(post) setPostData(post);
    }, [post])
        //botoes
        const clear = () => {
            setCurrentId(null);
            setPostData({criador: '', titulo: '', mensagem:'', tags: '',selectedFile: ''});
        };  
    const handleSubmit = (e) => {
        e.preventDefault();
        if(currentId){
            dispatch(updatePost(currentId,postData));
        } else {
            dispatch(createPost(postData));
        }
        clear();
    }
    return (
        <Paper className={classes.paper}>
            <form autoComplete="off" noValidate className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit}>
                <Typography variant="h6">{currentId ? 'Atualizando' : 'Criando'} projeto</Typography>
                <TextField name="criador" variant="outlined" label="Criador" fullWidth value={postData.criador} onChange={(e) => setPostData({ ...postData, criador: e.target.value})}/>
                <TextField name="titulo" variant="outlined" label="Titulo" fullWidth value={postData.titulo} onChange={(e) => setPostData({ ...postData, titulo: e.target.value})}/>
                <TextField name="mensagem" variant="outlined" label="Mensagem" fullWidth value={postData.mensagem} onChange={(e) => setPostData({ ...postData, mensagem: e.target.value})}/>
                <TextField name="tags" variant="outlined" label="Tags" fullWidth value={postData.tags} onChange={(e) => setPostData({ ...postData, tags: e.target.value.split(',')})}/>
                <div className={classes.fileInput}><FileBase type="file" multiple={false} onDone={({ base64 }) => setPostData({ ...postData, selectedFile: base64 })} /></div>
                <Button className={classes.buttonSubmit} variant="contained" color="primary" size="large" type="submit" fullWidth>Enviar</Button>
                <Button variant="contained" color="secondary" size="small" onClick={clear} fullWidth>Apagar</Button>
            </form>
        </Paper>
    );
};

export default Form;